import { IntegrationsPage as IntegrationsPageInner } from '@/features/integrations/IntegrationsPage';

export function IntegrationsPage() {
  return <IntegrationsPageInner />;
}
